import { cn } from "@/lib/utils";
import { containerStyles } from "@/lib/design-system/components";
import { HTMLAttributes } from "react";

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
}

export const Container = ({
  size,
  className,
  children,
  ...props
}: ContainerProps) => {
  return (
    <div
      className={cn(
        "px-4 w-full overflow-x-hidden",
        containerStyles({ size }), 
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};